export function getFormData<T extends readonly string[]>(
  form: HTMLFormElement,
  names: T
): { [TIndex in T[number]]: FormDataEntryValue } {
  const formData = new FormData(form);

  formData.values();
  type ReturnType = {
    [TIndex in (typeof names)[number]]: FormDataEntryValue;
  };
  let result: ReturnType = names.reduce((prev, cur) => {
    return { ...prev, [cur]: formData.get(cur) };
  }, {} as ReturnType);

  return result;
}
